module.exports = __webpack_public_path__ + "static/images/components/BuildingCardImage/images/arrow/arrow-base-100.a4e020f8.png";


//////////////////
// WEBPACK FOOTER
// ./components/BuildingCardImage/images/arrow/arrow-base-100.png
// module id = 2562
// module chunks = 11